// ./src/lib/FullScreen.js

/* global window, document */

// import Vue from 'vue';

/**
 * Toggle fullscreen function who work with webkit and firefox.
 * @function toggleFullscreen
 * @param {Object} event
 */
export const toggleFullscreenAlter = (event) => {
  let element = document.body;

  if (event instanceof HTMLElement) {
    element = event;
  }

  const isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
  const falseFunc = () => false;

  element.requestFullScreen = element.requestFullScreen
    || element.webkitRequestFullScreen
    || element.mozRequestFullScreen
    || falseFunc;
  document.cancelFullScreen = document.cancelFullScreen
    || document.webkitCancelFullScreen
    || document.mozCancelFullScreen
    || falseFunc;

  if (isFullscreen) {
    document.cancelFullScreen();
  } else {
    element.requestFullScreen();
  }
};

export const isFullScreen = () => {
  const doc = window.document;

  return !(!doc.fullscreenElement
    && !doc.mozFullScreenElement
    && !doc.webkitFullscreenElement);
};

export const toggleFullScreen = () => {
  const doc = window.document;
  const docEl = doc.documentElement;

  const requestFullScreen = docEl.requestFullscreen
    || docEl.mozRequestFullScreen
    || docEl.webkitRequestFullScreen;
  const cancelFullScreen = doc.exitFullscreen
    || doc.mozCancelFullScreen
    || doc.webkitExitFullscreen;

  if (requestFullScreen && !isFullScreen()) {
    requestFullScreen.call(docEl);
  } else if (cancelFullScreen) {
    cancelFullScreen.call(doc);
  }
};

export const isFullScreenAvailable = () => {
  const doc = window.document;
  const docEl = doc.documentElement;

  const requestFullScreen = docEl.requestFullscreen
    || docEl.mozRequestFullScreen
    || docEl.webkitRequestFullScreen;
  const cancelFullScreen = doc.exitFullscreen
    || doc.mozCancelFullScreen
    || doc.webkitExitFullscreen;

  return !!requestFullScreen && !!cancelFullScreen;
};
